import React from "react";
import style from "./OneMyOffer.module.css";
import {icons} from "../../../stuffs/Icons"
import {searchIcon} from "../../../stuffs/SearchIcon"
import { MdDomain, MdLocalPhone, MdEmail, MdWeb, MdDateRange } from 'react-icons/md'
import { VscVmActive } from "react-icons/vsc";
import {LatLngTuple} from "leaflet";

interface PropsOffer {
  name: string;
  shortName: string;
  website: string;
  email: string;
  phone: number | string;
  NIP: number | string;
  description: string;
  mainField: string;
  expirationDate: string | null;
  highlightedExpirationDate: string | null;
  recommendedExpirationDate: string | null;
  isActive: boolean | undefined;
}

const getPackageInfo = (
  expirationDate: string | null,
  highlightedExpirationDate: string | null,
  recommendedExpirationDate: string | null
): string => {
  const isValid = (date?: string | null): boolean => {
    if (!date) return false;

    const parsed = new Date(date);
    return !Number.isNaN(parsed.getTime()) &&
      parsed.getTime() >= Date.now();
  };

  if (isValid(recommendedExpirationDate)) {
    return `Polecane TOP 3 ważne do: ${recommendedExpirationDate}`;
  }

  if (isValid(highlightedExpirationDate)) {
    return `Wyróżnienie ważne do: ${highlightedExpirationDate}`;
  }

  if (isValid(expirationDate)) {
    return `Pakiet Rozszerzony ważny do: ${expirationDate}`;
  }

  return "Pakiet Darmowy – bezterminowo";
};

const OneMyOffer: React.FC<PropsOffer> = ({
  name,
  shortName,
  website,
  email,
  NIP,
  phone,
  mainField,
  expirationDate,
  highlightedExpirationDate,
  recommendedExpirationDate,
  isActive
}) => {

  const mainF = mainField;
  const icon = icons.filter(icon => icon.routing === mainF);
  return (
    <div className={style.Offer}>
      <div className={style.LeftBox}>{(icon[0] === undefined)? searchIcon[0].svg :icon[0].svg}</div>
      <div className={style.RightBox}>
        <div className={style.Name}>
          {name}
        </div>
        <div className={style.Row}>
          <div className={style.Icon}><MdLocalPhone /></div>
          <div className={style.Text}>{phone}</div>
          <div className={style.Icon}><MdDomain /></div>
          <div className={style.Text}>{NIP}</div>
        </div>
        <div className={style.Row}>
          <div className={style.Icon}><MdWeb /></div>
          <div className={style.Text}>{website}</div>
          <div className={style.Icon}><MdEmail /></div>
          <div className={style.Text}>{email}</div>
        </div>
        <div className={style.Row}>
          <div className={style.Icon}><MdDateRange /></div>
          <div className={style.Text}>{getPackageInfo(expirationDate, highlightedExpirationDate, recommendedExpirationDate)}</div>
          <div className={style.Icon}><VscVmActive /></div>
          <div className={style.Text}>Aktywna: {isActive ? 'Tak' : 'Nie'}</div>
        </div>
      </div>
    </div>
  );
};
export default OneMyOffer;
